import { render } from "./proviserservices.vue?vue&type=template&id=65ae9312&scoped=true"
import script from "./proviserservices.vue?vue&type=script&lang=js"
export * from "./proviserservices.vue?vue&type=script&lang=js"

import "./proviserservices.vue?vue&type=style&index=0&id=65ae9312&lang=scss"
import "./proviserservices.vue?vue&type=style&index=1&id=65ae9312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ae9312"]])

export default __exports__